import React, {useEffect, useRef, useState} from "react";
import styles from "./Invoice.module.css"
import {
    getErrors, getFullRequest,
    getInvoiceList, getInvoiceListApiVersion,
    getPreSignedUrl,
    getResult,
    getSteps,
    getTempFileLinks,
    sendInvoiceRequest
} from "../../services/api";
import axios from "axios";
import ReactJson from "react-json-view"
import {
    setErrorMessage,
    setInfoMessage,
    setLoading,
    useGlobalDispatch,
    useGlobalState
} from "../../context/GlobalState";
import {IoReload} from "react-icons/io5";
import {FaXmark} from "react-icons/fa6";

const getLastNDaysDate = (N) => {
    const today = new Date();
    const lastNDays = new Date(today.setDate(today.getDate() - N));
    return lastNDays.toISOString().split('T')[0]; // Format as YYYY-MM-DD
};
const getCurrentDate = (N) => {
    return new Date().toISOString().split('T')[0]; // Format as YYYY-MM-DD
};

function simplifyDateFormat2(input) {
    if (!input) return input;
    if (typeof input !== 'string') {
        return input;
    }
    const [date, timeWithMilliseconds] = input.split('T');
    const [year, month, day] = date.split('-');
    const [time] = timeWithMilliseconds.split('.');
    const [hour, minute] = time.split(':');

    return `${month}/${day} ${hour}:${minute}`;
}

const Invoice = () => {
    const dispatch = useGlobalDispatch();
    const {theme, layout, profile, loading} = useGlobalState();
    const [files, setFiles] = useState([]);
    // const [error, setError] = useState("");
    const [uploading, setUploading] = useState(false);
    const [dateFrom, setDateFrom] = useState(getLastNDaysDate(5));
    const [dateTo, setDateTo] = useState(getCurrentDate());
    const [requestList, setRequestList] = useState([]);
    const [detail, setDetail] = useState(null);
    const fileInputRef = useRef(null);

    useEffect(() => {
        const fetch_ = async () => {
            const data = await getInvoiceList(dateFrom, dateTo);
            setRequestList(data);
        }
        fetch_();
    }, []);

    const fetchRequestList = async () => {
        try {
            const data = await getInvoiceList(dateFrom, dateTo);
            setRequestList(data);
        } catch (error) {
            console.error("Error fetching data. call setErrorMessage()", error);
            dispatch(setErrorMessage(error));
        } finally {
        }
    };

    const fetchRequestListApiVersion = async () => {
        try {
            const data = await getInvoiceListApiVersion(dateFrom, dateTo);
            setRequestList(data);
        } catch (error) {
            dispatch(setErrorMessage(error));
            // console.error("Error fetching data:", error);
        } finally {
        }
    };


    // Handle file selection. Limit selection to a maximum of 3 files.
    const handleFileChange = (event) => {
        const selectedFiles = Array.from(event.target.files);
        // if (selectedFiles.length > 3) {
        //     setError("Please select up to 3 documents only.");
        //     return;
        // }
        setFiles(selectedFiles);
    };

    const loadResult = async (id) => {
        const result = await getResult(id);
        setDetail(result);
    }

    const loadFullRequest = async (id) => {
        const result = await getFullRequest(id);
        setDetail(result);
    }

    const loadSteps = async (id) => {
        const result = await getSteps(id);
        setDetail(result);
    }
    const loadErrors = async (id) => {
        const result = await getErrors(id);
        setDetail(result);
    }
    // Convert a file to a Base64 string using the FileReader API.
    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
                // The result is a data URL (e.g. "data:application/pdf;base64,...").
                // If desired, you can remove the prefix and keep only the Base64 part.
                let base64data = reader.result;
                if (typeof base64data === "string") {
                    // Strip off the "data:*/*;base64," prefix if needed.
                    const commaIndex = base64data.indexOf(",");
                    if (commaIndex !== -1) {
                        base64data = base64data.substring(commaIndex + 1);
                    }
                    resolve(base64data);
                } else {
                    reject("Unexpected result type");
                }
            };
            reader.onerror = (error) => reject(error);
            reader.readAsDataURL(file);
        });
    };

    const [fileSendMode, setFileSendMode] = useState("pre-signed link");

    // Handle form submission.
    const handleSubmit = async (event) => {
        event.preventDefault();

        // if (!files || files.length === 0) {
        //     setError("Please select at least one document to submit.");
        //     return;
        // }
        setUploading(true);
        dispatch(setLoading(true));

        try {
            // Convert each file to Base64.
            const documents = await Promise.all(
                files.map(async (file) => {
                    if (fileSendMode === "base64") {
                        console.log( "User base64")
                        const base64Content = await fileToBase64(file);
                        return {
                            file_name: file.name,
                            content_type: file.type,
                            content: base64Content,
                        };
                    } else {  //pre-link
                        console.log( "User pre-signed link")

                        // 1. Get the pre-signed URL for this file.
                        //    (Assuming getPreSignedUrl returns a URL string.)
                        const presignedUrl = await getPreSignedUrl(file.type, file.name);

                        // 2. Upload the file as bytes to the pre-signed URL.
                        //    Here we are using a PUT request, which is commonly used with storage services.
                        const uploadResponse = await axios.put(presignedUrl, file, {
                            headers: {
                                "Content-Type": file.type,
                            }
                        });

                        // 3. Return the document object.
                        //    Instead of sending "content" (Base64), we now send "file_url".
                        return {
                            file_name: file.name,
                            content_type: file.type,
                            file_url: presignedUrl, // You may need to adjust this if your public URL is different.
                        };
                    }
                })
            );

            // Build the payload matching your API schema.
            const payload = {
                request_type: "invoice", // Default or may be overridden by your API's logic.
                // Optionally add:
                // request_client_id: "your-client-id",
                // result_notify_callback_url: "http://your.callback.url",
                documents: documents,
                result_callback_url: callbackUrl,
                request_client_id: requestClientId,
            };

            // Call the API via sendInvoiceRequest.
            const response = await sendInvoiceRequest(payload);

            // Handle the response as needed.
            console.log("Response from API:", response);
            dispatch(setInfoMessage(`documents submitted successfully. response: ${JSON.stringify(response)}`))
            // Reset file input if desired.
            setFiles([]);
            if (fileInputRef.current) {
                fileInputRef.current.value = null;   // or ""
            }

        } catch (payload) {
            // setError(`Error: ${payload.message ?? JSON.stringify(payload)}`);
            dispatch(setErrorMessage(payload));
        } finally {
            setUploading(false);
            dispatch(setLoading(false));
        }
    };

    const generateLinkFor = async (index, id) => {
        try {
            const links = await getTempFileLinks(id)
            setRequestList(prevList =>
                prevList.map((item, i) =>
                    i === index ? {...item, file_links: links} : item
                )
            )
        } catch (error) {
            dispatch(setErrorMessage(error));
        }
    }

    const listDiv = (
        <div className={styles["data-container"]}>
            {requestList && (
                <div className={`${styles["item-row"]} ${styles["title"]}`}>
                    <div>uploaded at</div>
                    <div>tenant</div>
                    <div>id</div>
                    <div>step</div>
                    <div>outcome</div>
                    <div>modality</div>
                    <div>file links</div>
                    {/*<div>delete</div>*/}
                    <div>result</div>
                </div>
            )}
            {requestList.map((item, index) => (
                <div className={styles["item-row"]}
                >
                    <div>{simplifyDateFormat2(item.received_at)}</div>
                    <div>{(item?.tenant_id || '').slice(-4)}</div>
                    <div>{item.request_id}</div>
                    <div>{item.step_status}</div>
                    <div>{item.outcome}</div>
                    <div>{item?.modality}</div>
                    <div>
                        <button onClick={() => generateLinkFor(index, item.request_id)}>files..</button>
                        <div>
                            {(item?.file_links || []).map((f, index) => (
                                <div className={styles['link-line']}>
                                    {f?.url ? <a target="_blank" href={f.url}>{f.file_name}</a> : <>{f.file_name}</>}
                                </div>
                            ))}
                        </div>
                    </div>
                    {/*<div className={"fa-icon -smaller"} onClick={() => handleDelete(item._id)}>*/}
                    {/*    <FaRegTrashCan title="Delete"/>*/}
                    {/*</div>*/}
                    <div className={styles["action-buttons"]}>
                        <button onClick={() => loadResult(item.request_id)}>result...</button>
                        <button onClick={() => loadFullRequest(item.request_id)}>full view...</button>
                        {!!item?.step_log_count &&
                            <button onClick={() => loadSteps(item.request_id)}>logs.. ({item?.step_log_count})</button>}
                        {!!item?.error_log_count &&
                            <button className={styles["view-logs"]} onClick={() => loadErrors(item.request_id)}>errors..
                                ({item?.error_log_count})</button>}
                    </div>
                </div>
            ))}
        </div>
    )

    const divDateRange = (<div className={styles['date-range-selection']}>
            <div>
                <label>De: </label>
                <input
                    type="date"
                    name="date_from"
                    value={dateFrom}
                    onChange={(e)=>setDateFrom(e.target.value)}
                    placeholder="YYYY-MM-DD"
                />
            </div>
            <div>
                <label>Até: </label>
                <input
                    type="date"
                    name="date_to"
                    value={dateTo}
                    onChange={(e)=>setDateTo(e.target.value)}
                    placeholder="YYYY-MM-DD"
                />
            </div>
        </div>
    )

    const divSelectBase64 = (
        <div>
            <label>
                <input
                    type="radio"
                    value="base64"
                    checked={fileSendMode === "base64"}
                    onChange={(e) => setFileSendMode(e.target.value)}
                />
                Base64
            </label>
            <label>
                <input
                    type="radio"
                    value="pre-signed link"
                    checked={fileSendMode === "pre-signed link"}
                    onChange={(e) => setFileSendMode(e.target.value)}
                />
                Pre-signed Link
            </label>
            {/*<p>Selected mode: {fileSendMode}</p>*/}
        </div>
    )

    const divResult = !!detail && (<div className={styles['result-modal']}>
            <div className={styles['result-modal-panel']}>
                <div className={"fa-icon"}
                     onClick={()=>setDetail(null)}>
                    <FaXmark/>
                </div>
                {/*<button onClick={()=>setDetail(null)}>Close</button>*/}
            </div>
            <div className={styles['result-modal-content']}>
                <ReactJson src={detail} theme={theme === "light"? "rjv-default": "twilight"}/>
            </div>
        </div>)


    const [callbackUrl, setCallbackUrl] = useState('http://localhost:8005/webhook')
    const [requestClientId, setRequestClientId] = useState("optional-client-side-id")
    const divPanel = (
        <div className={styles['top-panel']}>
            {/*<h1>Invoice Requests</h1>*/}
            <form onSubmit={handleSubmit}
                  style={{display: "flex", flexDirection: "column", gap: "8px"}}
            >
                {/*{error && <div style={{color: "red", marginBottom: "1rem"}}>{error}</div>}*/}
                <div style={{display: "flex", flexDirection: "row", gap: "8px", alignItems: "center"}}>
                    <label htmlFor="fileInput">Select documents: </label>
                    <input
                        ref={fileInputRef}
                        style={{minWidth: "300px"}}
                        id="fileInput"
                        type="file"
                        accept=".pdf,.jpg,.jpeg,.png,.doc,.docx"
                        multiple
                        onChange={handleFileChange}
                    />
                </div>
                {files && files.map((f, index) => <div className={styles['selected-files']}>
                    <div>{f.name}</div>
                </div>)}
                {divSelectBase64}
                <div style={{display: "flex", flexDirection: "row", gap: "8px", alignItems: "center"}}>
                    <label htmlFor="callback_url">Callback url</label>
                    <input
                        type="text"
                        style={{minWidth: "500px"}}
                        value={callbackUrl}
                        onChange={(e) => setCallbackUrl(e.target.value)}
                    />

                </div>
                <div style={{display: "flex", flexDirection: "row", gap: "8px", alignItems: "center"}}>
                    <label htmlFor="requestClientId">Request client id</label>
                    <input
                        type="text"
                        style={{minWidth: "200px"}}
                        value={requestClientId}
                        onChange={(e) => setRequestClientId(e.target.value)}
                    />

                </div>
                <div style={{marginTop: "1rem"}}>
                    <button type="submit" disabled={uploading} className={'button-alert'}>
                        {uploading ? "Submitting..." : "Submit new request"}
                    </button>
                </div>
            </form>
            <hr className={'separator'}/>
            {divDateRange}
            <div className={styles["icons-panel"]}>
                <button type="button"
                        onClick={(e) => fetchRequestList()}
                        className={'button-alert  -with-icon'}>
                    Load
                    <IoReload/>
                </button>
                <button type="button"
                        onClick={(e) => fetchRequestListApiVersion()}
                        >
                    Load using API version
                </button>
            </div>
            {listDiv}
        </div>
    )

    const divDetail = (
        <div className={styles['top-detail']}>
            {divResult}
        </div>
    )

    return (
        <div className={styles['container']}>
            {divPanel}
            {!!detail && divDetail}
        </div>
    );
};

export default Invoice;
